import React, { useEffect, useState } from "react";
import {fetchAnnouncements} from "../../api";

export default function FloatingAnnouncements() {
  const [announcements, setAnnouncements] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const fetchlatestAnnouncements = async () => {
      try {
        const res = await fetchAnnouncements();  // Update if endpoint differs
        const data = await res;
        setAnnouncements(data);
      } catch (error) {
        console.error("Failed to fetch announcements:", error);
      }
    };

    fetchlatestAnnouncements();
  }, []);

  const handleOpen = (announcement) => {
    setSelected(announcement);
    setModalOpen(true);
  };

  const boxStyle = {
    position: "fixed",
    right: 0,
    top: "30%",
    width: "300px",
    background: "#fff",
    borderLeft: "3px solid #007bff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    padding: "1rem",
    borderRadius: "8px 0 0 8px",
    fontFamily: "Arial, sans-serif",
  };

  const ulStyle = {
    listStyle: "none",
    padding: 0,
    margin: 0,
  };

  const liStyle = {
    cursor: "pointer",
    padding: "0.5rem 0",
    textAlign: "right",
    borderBottom: "1px solid #eee",
    color: "#333",
  };

  const modalOverlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.4)",
    zIndex: 1100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const modalContentStyle = {
    background: "white",
    padding: "2rem",
    maxWidth: "600px",
    borderRadius: "12px",
    textAlign: "left",
    maxHeight: "80vh",
    overflowY: "auto",
  };
  const styles = {
    closeButton: {
      position: 'absolute',
      top: '0.5rem',
      right: '-20rem',
      color: '#6B7280',
      background: 'none',
      border: 'none',
      fontSize: '1.25rem',
      cursor: 'pointer',
    },
  };

  if (!announcements.length) return null;

  return (
    <>
      <div style={boxStyle}>
        <h4>📢 Announcements</h4>
        <ul style={ulStyle}>
          {announcements.map((a, index) => (
            <li
              key={index}
              style={liStyle}
              onMouseOver={(e) => (e.target.style.color = "#007bff")}
              onMouseOut={(e) => (e.target.style.color = "#333")}
              onClick={() => handleOpen(a)}
            >
              {a.title.length > 80 ? a.title.slice(0, 77) + "..." : a.title}
            </li>
          ))}
        </ul>
      </div>

      {modalOpen && selected && (
        <div style={modalOverlayStyle} onClick={() => setModalOpen(false)}>
          <div
            style={modalContentStyle}
            onClick={(e) => e.stopPropagation()}
          >

            <h3>{selected.title}</h3>
            <div dangerouslySetInnerHTML={{ __html: selected.content }} />
            <button onClick={() => setModalOpen(false)} style={{ marginTop: "1rem" }}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
